export const HOME = '/';
export const ADMIN = '/admin';
export const ADMIN_GAME = '/admin/:gameID';
export const ABOUT = '/about';
export const RULES = '/rules';
export const TEAM = '/team/:teamNumber';
export const GAMES = '/games';